
import { mapGetters } from "vuex";
import mixins from "vue-typed-mixins";
import Common from "@/mixins/Common";

export default mixins(Common).extend({
  mixins: [Common],
  name: "quest-wrapper-component",
  props: {
    step: { default: "pay", type: String },
    stepType: { default: "none", type: String },
    visittypeid: { default: 0, type: Number },
    paymentOnly: { default: false, type: Boolean },
    disableProductSelection: { default: false, type: Boolean },
    noProductReview: { default: false, type: Boolean },
    noDrReview: { default: false, type: Boolean },
    readonly: { default: false, type: Boolean },
    isRx: { default: false, type: Boolean },
    chooseProductPriorToAuth: { type: Boolean, default: false },
    getStartedProductsAfterQuestionnaire: { type: Boolean, default: false },
    isRenewal: { type: Boolean, default: false },
    confirmTerms: { default: false, type: Boolean },
    useModifyFlowForRefills: { type: Boolean, default: false },
    isAfterCheckout: { default: false, type: Boolean },
    hasQuestions: { default: true, type: Boolean },
    showsSubscriptionInQuestionnaire: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      Lang: "getLang",
    }),
    notshow() {
      return !this.show;
    },
    medClass() {
      return { current: this.step === "med" ? true : false };
    },
    queClass() {
      return { current: this.step === "que" ? true : false };
    },
    payClass() {
      return { current: this.step === "pay" ? true : false };
    },
    conClass() {
      return { current: this.step === "con" ? true : false };
    },
    visClass() {
      return { current: this.step === "vis" ? true : false };
    },
    basClass() {
      return { current: this.step === "bas" ? true : false };
    },
    photoClass() {
      return { current: this.step === "photo" ? true : false };
    },
    subClass() {
      return { current: this.step === "sub" ? true : false };
    },
    visitRequired() {
      console.log("TYPE", this.visittypeid);
      if (this.visittypeid == 1) {
        return true;
      } else return false;
    },
  },
});
